/**
 * @author lihh
 * @description 表示个人中心 面试邀约
 */
// 导入axios
import request from '@/utils/request';

import {
    SERVICE_TYPE_HPM
} from '@/utils/define';

/**
 * @author lihh
 * @description 表示浏览记录
 * @param {*} data 
 * @param current 表示页数
 * @param size 表示每页条数
 */
export function myInterview(current = 1, size = 6, data = {}) {

    // 表示需要toekn
    data['tokenNeed'] = 1;

    return request({
        url: `/${SERVICE_TYPE_HPM}/User/MyInterview?current=${current}&size=${size}`,
        method: 'POST',
        data
    });
}

/**
 * @author lihh
 * @description 线上 线下面试 修改已读 最新状态
 */
export function InterviewRead(ids = "", data = {}) {

    // 表示需要toekn
    data['tokenNeed'] = 1;

    return request({
        url: `/${SERVICE_TYPE_HPM}/Operate/InterviewRead?ids=${ids}`,
        method: 'POST',
        data
    });
}

/**
 * @author lvcx
 * @description 个人中心-面试详情
 * @param data 表示参数
 */
export function InterviewDetail(id,data = {}) {  
  // 表示需要toekn
  data['tokenNeed'] = 1;
  data['isLoading'] = false;
  return request({
      url: `/${SERVICE_TYPE_HPM}/User/InterviewDetail?id=${id}`,
      method: 'POST',
      data
  });
}


// WEBPACK FOOTER //
// ./src/api/request/oralInviteService.js